export const YOURCALL_DATA_PROVIDER = {
    BYB: 'BYB',
};
